import { filter, map, sortBy } from "lodash";
import { useEffect, useState } from "react";

export const useUserSelectMulti = ({ sort, options, value }) => {
    const initOptions = sort ? sortBy(map(options, (option, idx) => ({
        value: idx,
        label: option,
    })), 'value') : map(options, (option, idx) => ({
        value: idx,
        label: option,
    }));
    const [optionArr, setOptionArr] = useState(initOptions);
    const [selectedValue, setSelectedValue] = useState([]);

    useEffect(() => {
        const selectedArr = filter(optionArr, (item) => value?.includes(item.value));

        setSelectedValue([...selectedArr]);
    }, [value]);

    useEffect(() => {
        if (sort) {
            setOptionArr(sortBy([...map(options, (option, idx) => ({ value: idx, label: option }))], 'value'));
        } else {
            setOptionArr([...map(options, (option, idx) => ({ value: idx, label: option }))]);
        }
    }, [options]);

    return { selectedValue, optionArr };
};